import Widget from "csi/html/Widget";
import { hasModule } from "csi/_base/modules";
import declare from "dojo/_base/declare";
import { FOOD_MODULE } from "./PPService";

export = declare(Widget, {
	/**
	 * @override
	 * hide the Food setting if Food module is not installed yet
	 */
	_processKey(ctx, key, def, domNode) {
		if (key === "5" && !hasModule(FOOD_MODULE)) {
			return null;
		}

		return this.inherited(arguments);
	},
});